/* eslint-disable no-template-curly-in-string */
import * as yup from 'yup';

declare module 'yup' {
  interface StringSchema {
    phoneNumber(): StringSchema;
    personalCodeEE(): StringSchema;
  }
}

yup.setLocale({
  mixed: {
    required: 'form.fieldError.required',
  },
});

yup.addMethod(yup.string, 'phoneNumber', function () {
  return this.matches(/^\d+$/, 'form.fieldError.phoneNumber');
});

yup.addMethod(yup.string, 'personalCodeEE', function () {
  return this.matches(/^\d+$/, 'form.fieldError.personalCodeEE')
    .min(11, 'form.fieldError.personalCodeEE')
    .max(11, 'form.fieldError.personalCodeEE')
    .required();
});

export default yup;
